<p-dropdown [panelStyleClass]="styleClass"
            [styleClass]="styleClass"
            [disabled]="!serviceTypes"
            [options]="serviceTypes"
            optionLabel="code"
            [(ngModel)]="selectedServiceType"
            [filter]="true"
            filterBy="code,description"
            [showClear]="true"
            [placeholder]="'OPTIONS.SERVICE_TYPE_PICKER_PLACEHOLDER' | translate"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            autoWidth="false"
            [style]="{ width: '250px' }">
  <ng-template pTemplate="selectedItem">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: selectedServiceType }"></ng-container>
  </ng-template>

  <ng-template let-item
               pTemplate="item">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
  </ng-template>
</p-dropdown>

<ng-template #itemTemplate
             let-serviceType>
  <div *ngIf="serviceType"
       class="pop-service-type-picker-item">
    {{ serviceType.code }} {{' \u2022 '}} {{ serviceType.description }}
  </div>
</ng-template>
